<!--
 * @Author: yuankun yuankun0310@126.com
 * @Date: 2022-06-27 20:16:32
 * @LastEditors: yuankun yuankun0310@126.com
 * @LastEditTime: 2022-07-28 16:54:09
 * @FilePath: /shopManagement/src/pages/purseSetting/binding/components/accountCardLL.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="account-card-ll">
    <div class="accont-area flex-row-start-center">
      <img :src="img.userIcon" width="48" alt="" />
      <span class="fs-14 account-label">连连账号:</span>
      <span class="fs-14 account-value">{{
        pageAccountWithCorpInfoVO.clearingAccountNo
      }}</span>
      <el-tag :class="`fs-14 tag-color ${pageActivationVO.activation ? 'has-activation' : 'not-activation'
        }`
        ">{{ pageActivationVO.activation ? "已激活" : "未激活" }}</el-tag>
      <span class="not-activation-label fs-14" v-if="!pageActivationVO.activation">连连账户钱袋提现前，需要激活账户</span>
    </div>
    <div class="man-content-area">
      <!-- 银行信息 -->
      <div class="card-item">
        <div class="card-title flex-row-between-center">
          <div class="title-left flex-flex1 flex-row-start-center">
            <img :src="img.bankLogo" :width="20" alt="" />
            <span class="title-text">银行信息</span>
          </div>
          <el-alert v-if="pageAccountWithModifyBankVo.status === 1" title="换绑中，请耐心等待..." type="info" show-icon
            class="is-going">
          </el-alert>
        </div>
        <div class="card-body">
          <el-row :gutter="8">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">账户类型:</div>
                <div class="value">
                  {{
                    pageAccountWithBankAccountVO.accountType
                      ? pageAccountWithBankAccountVO.accountType === 1
                        ? "对公账户"
                        : " 个人账户"
                      : ""
                  }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">
                  {{
                    pageAccountWithBankAccountVO.accountType
                      ? pageAccountWithBankAccountVO.accountType === 1
                        ? "账户名称:"
                        : "银行户名:"
                      : ""
                  }}
                </div>
                <div class="value">

                  <MaskViewVue type="maskName" :maskVal="pageAccountWithBankAccountVO.accountName" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">
                  {{
                    pageAccountWithBankAccountVO.accountType
                      ? pageAccountWithBankAccountVO.accountType === 1
                        ? "账户号码:"
                        : "银行卡号:"
                      : ""
                  }}
                </div>
                <div class="value">

                  <MaskViewVue type="maskBankCard" :maskVal="pageAccountWithBankAccountVO.accountNumber" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">银行卡预留手机号:</div>
                <div class="value">

                  <MaskViewVue type="maskPhone" :maskVal="pageAccountWithBankAccountVO.reservePhone" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">开户银行:</div>
                <div class="value">
                  {{ pageAccountWithBankAccountVO.bankName }}
                </div>
                <el-button v-if="
                  activationVO.activation &&
                  pageAccountWithModifyBankVo.status !== 1
                " type="primary" size="small" class="jump-qf-btn" @click="handleJumpUpdateCard">换绑银行卡</el-button>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">省份:</div>
                <div class="value">
                  {{ pageAccountWithBankAccountVO.provinceName }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">市/县:</div>
                <div class="value">
                  {{ pageAccountWithBankAccountVO.cityName }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">开户支行:</div>
                <div class="value">
                  {{ pageAccountWithBankAccountVO.branchBankName }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">开户行地址:</div>
                <div class="value">
                  {{ pageAccountWithBankAccountVO.branchBankName }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 商户信息 -->
      <div class="card-item">
        <div class="card-title flex-row-between-center">
          <div class="title-left flex-flex1 flex-row-start-center">
            <img :src="img.accountLogo" :width="20" alt="" />
            <span class="title-text">商户信息</span>

          </div>
          <el-alert v-if="pageAccountWithModifyPhoneVo.status === 1" title="换绑中，请耐心等待..." type="info" show-icon
            class="is-going">
          </el-alert>
        </div>
        <div class="card-body">
          <el-row :gutter="8">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">法定代表人:</div>
                <div class="value">
                  <MaskViewVue type="maskName" :maskVal="pageAccountWithUserInfoVO.realName" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">证件类型:</div>
                <div class="value">身份证</div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">证件号码:</div>
                <div class="value">
                  <MaskViewVue type="maskBankCard" :maskVal="pageAccountWithUserInfoVO.certNumber" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">法定代表人手机号:</div>
                <div class="value">
                  <MaskViewVue type="maskPhone" :maskVal="pageAccountWithUserInfoVO.mobile" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">注册邮箱:</div>
                <div class="value">
                  <MaskViewVue type="maskEmail" :maskVal="pageAccountWithCorpInfoVO.mail" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">企业名称:</div>
                <div class="value">
                  {{ pageAccountWithCorpInfoVO.corpName }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">营业执照类型:</div>
                <div class="value">
                  {{
                    pageAccountWithCorpInfoVO.licenseType === 1
                      ? "有限公司"
                      : pageAccountWithCorpInfoVO.licenseType === 2
                        ? "个人独资企业"
                        : "个体工商户"
                  }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">营业执照企业名称:</div>
                <div class="value">
                  {{ pageAccountWithCorpInfoVO.licenseName }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">注册手机号:</div>
                <div class="value">
                  <MaskViewVue type="maskPhone" :maskVal="pageAccountWithCorpInfoVO.phone" :customParams="{
                    expand: JSON.stringify({
                      xAPIVersion: 'V1.0',
                      xSystemID: 'passport',
                    }),
                  }" />
                </div>
                <el-button v-if="
                  activationVO.activation &&
                  pageAccountWithModifyPhoneVo.status !== 1
                " type="primary" size="small" class="jump-qf-btn" @click="handleJumpUpdatePhone">换绑注册手机号</el-button>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">统一社会信用代码:</div>
                <div class="value">
                  {{ pageAccountWithCorpInfoVO.licenseNumber }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">证件有效期:</div>
                <div class="value">
                  {{
                    `${pageAccountWithUserInfoVO.validBeginTime || ""}——${pageAccountWithUserInfoVO.validTerm
                      ? pageAccountWithUserInfoVO.validTerm
                      : pageAccountWithUserInfoVO.validEndTime || ""
                    }`
                  }}
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <div class="flex-row-start-center flex-item">
                <div class="label">企业地址:</div>
                <div class="value">
                  {{ pageAccountWithCorpInfoVO.detailAddress }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div v-if="!activationVO.activation" class="not-activation-btn-area">
      <el-button type="primary" size="large" class="jump-qf-btn" @click="handleJumpActivation">去激活</el-button>
    </div>
  </div>
</template>

<script>
import userIcon from "@/assets/img/user-icon.png";
import bankLogo from "@/assets/img/bankLogo.png";
import accountLogo from "@/assets/img/accountLogo.png";
import eyeClose from "@/assets/img/eyeClose.png";
import eyeOpen from "@/assets/img/eyeOpen.png";
// utils
import { replaceStr } from "@/utils/utils";
// api
import { getStatusFlag } from "@/models/purseSet";
import { MaskViewVue } from "ruigu-utils";
export default {
  name: "accountCardLL",
  props: {
    activationVO: {
      type: Object,
      default: function () {
        return {
          activation: false,
          corpId: 0,
          open: false
        };
      }
    },
    accountWithModifyBankVo: {
      type: Object,
      default: function () {
        return {
          statue: false,
          failMessage: null,
          time: null
        };
      }
    },
    accountWithModifyPhoneVo: {
      type: Object,
      default: function () {
        return {
          statue: false,
          failMessage: null,
          time: null
        };
      }
    },
    accountWithCorpInfoVO: {
      // 是否开户、激活
      type: Object,
      default: function () {
        return {
          clearingAccountNo: null,
          activation: false,
          corpId: 0,
          corpType: 0,
          accountName: null,
          accountNumber: null,
          mail: null,
          mobile: null,
          phone: null,
          corpName: null,
          detailAddress: null
        };
      }
    },
    accountWithUserInfoVO: {
      // 是否开户、激活
      type: Object,
      default: function () {
        return {
          activation: false,
          corpId: 0,
          corpType: 0,
          accountName: null,
          accountNumber: 0,
          certNumber: null,
          validTerm: null,
          validBeginTime: null,
          validEndTime: null
        };
      }
    },
    accountWithBankAccountVO: {
      type: Object,
      default: function () {
        return {
          accountType: null,
          activation: false,
          corpId: null,
          corpType: null,
          accountName: null,
          accountNumber: null,
          reservePhone: null,
          bankName: null,
          branchBankName: null,
          provinceName: null,
          cityName: null
        };
      }
    }
  },
  components: {
    MaskViewVue
  },
  data() {
    return {
      img: {
        userIcon,
        bankLogo,
        accountLogo,
        eyeClose,
        eyeOpen
      },
      pageActivationVO: {
        activation: false,
        corpId: 0,
        open: false
      },
      pageAccountWithCorpInfoVO: {
        clearingAccountNo: null,
        corpId: 0,
        corpType: 0,
        activation: false,
        mail: null,
        licenseName: null,
        corpName: null,
        licenseNumber: null,
        licenseNumberHide: null,
        detailAddress: null,
        phone: null,
        phoneHide: null
      }, // 账户信息
      pageAccountWithUserInfoVO: {
        certNumber: null,
        certNumberHide: null,
        mobile: null,
        mobileHide: null,
        validTerm: null,
        validBeginTime: null,
        validEndTime: null
      },
      pageAccountWithBankAccountVO: {
        accountType: null,
        accountName: null,
        accountNumber: null,
        accountNumberHide: null,
        reservePhone: null,
        reservePhoneHide: null,
        bankName: null,
        branchBankName: null,
        provinceName: null,
        cityName: null
      },
      pageAccountWithModifyBankVo: {
        status: null
      },
      pageAccountWithModifyPhoneVo: {
        status: null
      },
    };
  },

  computed: {},

  methods: {

    /**
     * @description: 跳转清分公共系统-激活
     */
    async handleJumpActivation() {
      try {
        const resData = await getStatusFlag({
          corpId: this.pageActivationVO.corpId
        });
        const data = resData.data || null;
        if (data) {
          const jumpUrl = threepublic;
          if (data.activationAndPapStatus !== -1) {
            // 激活中 || 已激活
            const message =
              data.activationAndPapStatus === 0
                ? "账户正在激活中，请稍后操作！"
                : "账户已激活！";
            this.$message.warning(message);
            this.$emit("handleReloadTab"); // 刷新当前tab
            return;
          }
          window.open(
            `${jumpUrl}/account-activation?corpId=${this.pageActivationVO.corpId
            }&token=${localStorage.getItem("token")}&c_type=4`
          );
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    /**
     * @description: 跳转清分公共系统-换绑手机号
     */
    async handleJumpUpdatePhone() {
      try {
        const resData = await getStatusFlag({
          corpId: this.pageActivationVO.corpId
        });
        const data = resData.data || null;
        if (data) {
          const jumpUrl = threepublic;
          if (data.modifyPhoneStatus === 0) {
            this.$message.warning("账户正在换绑中，请稍后操作！");
            this.$emit("handleReloadTab"); // 刷新当前tab
            return;
          }
          window.open(
            `${jumpUrl}/change-phone-number?corpId=${this.pageActivationVO.corpId
            }&token=${localStorage.getItem("token")}&c_type=4`
          );
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * @description: 跳转清分公共系统-换绑银行卡
     */
    async handleJumpUpdateCard() {
      try {
        const resData = await getStatusFlag({
          corpId: this.pageActivationVO.corpId
        });
        const data = resData.data || null;
        if (data) {
          const jumpUrl = threepublic;
          if (data.modifyBankStatus === 0) {
            this.$message.warning("账户正在换绑中，请稍后操作！");
            this.$emit("handleReloadTab"); // 刷新当前tab
            return;
          }
          window.open(
            `${jumpUrl}/change-bank-card?corpId=${this.pageActivationVO.corpId
            }&token=${localStorage.getItem("token")}&c_type=4`
          );
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  },

  created() { },

  mounted() { },


  watch: {
    activationVO: {
      handler: function (val) {
        this.pageActivationVO = val;
      },
      immediate: true
    },
    accountWithModifyBankVo: {
      handler: function (val) {
        this.pageAccountWithModifyBankVo = val;
      },
      immediate: true
    },
    accountWithModifyPhoneVo: {
      handler: function (val) {
        this.pageAccountWithModifyPhoneVo = val;
      },
      immediate: true
    },
    accountWithCorpInfoVO: {
      handler: function (val) {
        this.pageAccountWithCorpInfoVO = {
          ...(val || {}),
          licenseNumberHide: replaceStr(
            String(val.licenseNumber || ""),
            4,
            "**********"
          ), // 🈺营业执照脱敏,
          phoneHide: replaceStr(String(val.phone || ""), 3, "****") // 绑定手机号脱敏,
        };
      },
      immediate: true
    },
    accountWithUserInfoVO: {
      handler: function (val) {
        this.pageAccountWithUserInfoVO = {
          ...(val || {}),
          certNumberHide: replaceStr(
            String(val.certNumber || ""),
            4,
            "**********"
          ), // 身份证号脱敏,
          mobileHide: replaceStr(String(val.mobile || ""), 3, "****") // 法人手机号脱敏,
        };
      },
      immediate: true
    },
    accountWithBankAccountVO: {
      handler: function (val) {
        this.pageAccountWithBankAccountVO = {
          ...(val || {}),
          accountNumberHide: replaceStr(
            String(val.accountNumber || ""),
            4,
            "**********"
          ), // 银行卡号脱敏
          reservePhoneHide: replaceStr(
            String(val.reservePhone || ""),
            3,
            "****"
          ) // 预留手机号脱敏,
        };
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.account-card-ll {
  height: 100%;

  .account-label {
    color: #262626;
    margin-left: 15px;
  }

  .account-value {
    color: #595959;
    margin-right: 15px;
  }

  .not-activation-label {
    color: #ffaa00;
    margin-left: 15px;
  }

  .has-activation {
    background-color: #f6ffed;
    color: #52c41a;
    border-color: #52c41a;
  }

  .not-activation {
    background-color: #fffbe6;
    color: #faad14;
    border-color: #ffe58f;
  }

  .man-content-area {
    margin-top: 15px;
    padding: 20px 0;
    border-top: 1px solid #e9e9e9;
  }

  .card-item {
    &:last-child {
      margin-top: 30px;
    }

    .card-title {
      margin-bottom: 10px;

      .title-text {
        margin: 0 10px;
        font-size: 16px;
        font-weight: 500;
      }

      .is-going {
        width: 220px;
      }
    }

    .card-body {
      .flex-item {
        margin-top: 10px;
      }

      .label {
        color: #262626;
        font-size: 14px;
        line-height: 26px;
        flex-shrink: 0;
        flex-basis: 150px;
      }

      .value {
        padding-left: 10px;
        color: #595959;
        font-size: 14px;
        line-height: 26px;
      }

      .jump-qf-btn {
        margin-left: 10px;
      }
    }
  }

  .not-activation-btn-area {
    position: absolute;
    z-index: 10;
    width: 100%;
    bottom: 0;
    margin-left: -15px;
    margin-right: -15px;
    text-align: center;
    border-top: 1px solid #e9e9e9;
    padding: 20px 0;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/binding/components/accountCardLL.vue